import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { FeedbackModel } from './feed'
import { Feedback } from './feedback';
import { HttpManagerService } from '../../api/httpmanager.service';
@Injectable()
export class FeedbackService {
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    allFeedback(data): Promise<FeedbackModel[]> {
        return this.httpmanagerService.HttpPost('sfeedback/allfeedback', JSON.stringify(data), "").then(data => {
            return data.data;
        })
    }
    deleteFeedback(id): Promise<Feedback> {
        return this.httpmanagerService.HttpDelete('sfeedback', id).then(data => {
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/feedback/feedback.service.ts